import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ObserveControl } from 'console/shared/contexts/observe-control/types';
import { overlay_variants, panel_variants, SwipableOverlay, } from 'console/shared/styles/components/swipable';
import { WindowContext } from 'console/shared/contexts/window/types';
import * as S from '../styles';
import { createPortal } from 'react-dom';
import { useBox } from 'shared/hooks/utils';
import { pop_back_item, push_back_item } from 'console/utils/back-button';
//TODO новые версии работают только с 18 реактом
const SwipableModal = memo(function SwipableModal(props) {
    const { children, opened } = props;
    const { disabled_modal_interaction, drag_controls, onClose } = useContext(ObserveControl);
    const boxedClose = useBox(onClose);
    const onBackClose = useCallback(() => {
        boxedClose.current?.();
    }, []);
    const onEnter = useCallback(() => push_back_item(onBackClose), [onBackClose]);
    const onExit = useCallback(() => pop_back_item(onBackClose, false), [onBackClose]);
    const { size } = useContext(WindowContext);
    const onDragEnd = useCallback((_, info) => {
        if (info.offset.y > 150 && !disabled_modal_interaction) {
            onBackClose();
        }
    }, [disabled_modal_interaction]);
    useEffect(() => {
        const close = (event) => {
            if (event.key === 'Escape' || event.key === 'ArrowDown') {
                onBackClose();
            }
        };
        window.addEventListener('keydown', close);
        return () => window.removeEventListener('keydown', close);
    }, []);
    const onOverlayPointerDown = useCallback((event) => {
        drag_controls?.start(event);
    }, [drag_controls]);
    return createPortal(_jsx(AnimatePresence, { exitBeforeEnter: true, onExitComplete: onExit, children: opened && (_jsxs(_Fragment, { children: [_jsx(SwipableOverlay, { className: "swipable-overlay", initial: "hidden", animate: "visible", exit: "exit", onClick: onBackClose, variants: overlay_variants, onPointerDown: onOverlayPointerDown }), _jsx(S.SwipableModal, { className: "swipable-modal", drag: "y", dragControls: drag_controls, dragListener: false, onDragEnd: onDragEnd, initial: "hidden", dragDirectionLock: true, animate: "visible", exit: "hidden", variants: panel_variants, dragConstraints: {
                        top: 0,
                        bottom: 0,
                    }, dragElastic: { top: 0, bottom: 1, left: 0, right: 0 }, size: size, onAnimationStart: (animation_name) => {
                        if (animation_name === 'visible') {
                            onEnter();
                        }
                    }, onAnimationComplete: (animation_name) => {
                        if (animation_name === 'hidden') {
                            onExit();
                            onClose();
                        }
                    }, children: children })] })) }), document.body);
});
export { SwipableModal };
